<div class="vl"></div>
<ion-buttons slot="primary">
    <ion-button class="btn-round" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close" size="small"></ion-icon>
    </ion-button>
</ion-buttons>

<div class="content">
    <div class="head">
        <ion-icon name="settings"></ion-icon>
        <span>{{'__VIDEOCHAT_SETTING_UP_HEADER__' | translate}}</span>
    </div>
    <div class="setting-part">
        <div class="devices">
            <!-- Mic devices -->

            <div id="audioItem">
                <ng-select class="ion-select" [(ngModel)]="audioDevice" (ngModelChange)="setAudioDevice($event)"
                           [searchable]="false" [clearable]="false"
                           (focusin)="$event.stopPropagation()"
                           [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                           [placeholder]="'__VIDEOCHAT_SETTING_UP_AUDIO_DEVICES__' | translate">
                    <ng-option [value]="'None'">{{'__VIDEOCHAT_SETTING_UP_DISABLE__' | translate}}</ng-option>
                    <ng-option *ngFor="let device of audioDevices" [value]="device">{{device.label}}
                    </ng-option>
                </ng-select>
            </div>

            <!-- Cam devices -->
            <div id="videoItem">
                <ng-select class="ion-select" [(ngModel)]="videoDevice" (ngModelChange)="setVideoDevice($event)"
                           [searchable]="false" [clearable]="false"
                           (focusin)="$event.stopPropagation()"
                           [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                           [placeholder]="'__VIDEOCHAT_SETTING_UP_CAM_DEVICES__' | translate">
                    <ng-option [value]="'None'">{{'__VIDEOCHAT_SETTING_UP_DISABLE__' | translate}}</ng-option>
                    <ng-option *ngFor="let device of videoDevices" [value]="device">{{device.label}}
                    </ng-option>
                </ng-select>
            </div>
        </div>

        <ion-button id="join-button" (click)="join()" expand="block" shape="round" color="primary">{{'__VIDEOCHAT_SETTING_UP_SAVE__' | translate}}</ion-button>

    </div>
</div>
